import { createQueryKeys } from "@lukemorales/query-key-factory";
import { skipToken } from "@tanstack/react-query";

import { listSignedConsentDocuments } from "~/providers/api/consentDocuments";
import { SignedConsentDocumentsRequest } from "~/providers/types/consentDocuments";

export const signedConsentDocumentsQueryOptionsFactory = createQueryKeys(
  "signed-consent-documents",
  {
    list: ({ organizationId, patientId }: SignedConsentDocumentsRequest) => ({
      queryKey: [organizationId, patientId],
      queryFn:
        organizationId && patientId
          ? () => listSignedConsentDocuments({ organizationId, patientId })
          : skipToken,
    }),
  },
);
